import React from "react";
import styled from "styled-components";
import StackingConnectWallet from "../StackingConnectWallet";
import styles from "./header.module.scss";
import Logo from "../../utils/svgs/shinobi-logo.png";
function StackingHeader() {
  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        <img src={Logo} alt="Logo" />
      </div>
      <Header>
        <div className={styles.text}>SHINO STAKING PLATFORM</div>
        <StackingConnectWallet />
      </Header>
    </div>
  );
}

export default StackingHeader;

const Header = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  justify-content: space-between;
  padding: 1rem;
  width: 60%;
  background-color: rgba(0, 0, 0, 0.50);
  border: 1px solid red;
  height: 60px;
  backdrop-filter: blur(3px);
  @media (max-width: 768px) {
    max-width: 60%;
    padding: 0rem;
    align-items: center;
    justify-content: center;
    border: none;
    background: none;
    box-shadow: none;
  }
`;
